import React, { useContext, useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement, AddressElement, } from "@stripe/react-stripe-js";
import AuthContext from "../../Context/AuthContext";
import { createCustomer, fetchOrganisationDetails, fetchPaymentMethodId, fetchSavedCards } from "../../api";
import { useNavigate, useParams } from "react-router-dom";
import paymentDropdown from "../../Assets/Images/paymentDropdown.svg";
import cvc from "../../Assets/Images/CVC.svg";
import mastercard from "../../Assets/Images/mastercard.png";
import visa from "../../Assets/Images/visa.png";
import ax from "../../Assets/Images/ax.png";
import jcb from "../../Assets/Images/jcb.png";
import { CircularProgress } from "@mui/material";

const stripePromise = loadStripe(
  `${process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY}`
);
const cardElementStyle = {
  options: {
    autoComplete: "off"
  },
  style: {
    base: {
      fontSize: "16px",
      color: "#32325d",
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', "::placeholder": { color: "#aab7c4", },
      iconColor: "#666EE8", ":-webkit-autofill": { color: "#32325d", },
      padding: "10px 12px",
      border: "1px solid #e4e4e4",
      borderRadius: "4px",
      backgroundColor: "white",
    },
    invalid: { color: "#fa755a", iconColor: "#fa755a", },
  },
};

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const { orgId } = useParams()

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({ cardinfo: "", cardholdername: "", address: false, });
  const [cardFocused, setCardFocused] = useState(false)

  const handleCardChange = (event, field) => {
    setErrors((prev) => ({
      ...prev,
      [field]: event.error ? event.error.message : "",
    }));
  };

  const token = localStorage.getItem("token")

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrors({
      cardinfo: "",
      cardholdername: "",
      address: true,
    });

    let hasErrors = false;

    const cardNumberElement = elements.getElement(CardNumberElement);
    const cardExpiryElement = elements.getElement(CardExpiryElement);
    const cardCvcElement = elements.getElement(CardCvcElement);
    const addressElement = elements.getElement('address');
    const { value } = await addressElement.getValue();

    // if (!cardNumberElement?._complete) {
    //   setErrors((prevErrors) => ({
    //     ...prevErrors,
    //     cardinfo: "Please enter a valid card number.",
    //   }));
    //   hasErrors = true;
    // }
    // if (!cardExpiryElement?._complete) {
    //   setErrors((prevErrors) => ({
    //     ...prevErrors,
    //     cardexpiry: "Please enter a valid expiry date.",
    //   }));
    //   hasErrors = true;
    // }

    // if (!cardCvcElement?._complete) {
    //   setErrors((prevErrors) => ({
    //     ...prevErrors,
    //     cardcvc: "Please enter a valid CVC code.",
    //   }));
    //   hasErrors = true;
    // }

    // if ( !errors?.address ) {
    //   hasErrors = true;
    // }


    setIsProcessing(true);
    setMessage("");

    try {
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: cardNumberElement,
        billing_details: {
          name,
          email,
          address: {
            line1: value.address.line1,
            line2: value.address.line2,
            city: value.address.city,
            state: value.address.state,
            postal_code: value.address.postal_code,
            country: value.address.country,
          },
        },
      });


    // console.log("errors,hasErrors",errors,hasErrors, paymentMethod)
      if ( errors?.address == false ) {
        setIsProcessing(false)
        return
      }

      if (error) {
        console.error("Stripe Error:", error);
        console.log("Stripe Error:", error);
        setMessage(error.message);

        if (error.code === "card_declined") {
          setMessage("Your card was declined. Try another card.");
        } 
        else if (error.code === "incorrect_cvc") {
          setErrors((prevErrors) => ({
            ...prevErrors,
            cardcvc: "The CVC code is incorrect.",
          }));
        } 
        else if (error.code === "invalid_expiry_month" || error.code === "invalid_expiry_year") {
          setErrors((prevErrors) => ({
            ...prevErrors,
            cardexpiry: "Invalid expiration date.",
          }));
        } 
        else if (error.code === "invalid_number") {
          setErrors((prevErrors) => ({
            ...prevErrors,
            cardinfo: "Invalid card number.",
          }));
        }

        setIsProcessing(false);
        return;
      }
      else if (paymentMethod) {

        const data = await createCustomer(email, name, orgId, paymentMethod?.id);

        if (data.status === "success") {
          console.log("checkout form v2", data);
          authCtx.addCustomerId(data?.customerId);
          const paymentMethodId = await fetchSavedCards(data?.customerId, token)
          authCtx?.addPaymentMethodId(paymentMethodId[0]?.id)
          console.log("paymentMethodId", paymentMethodId[0]?.id)
          if (paymentMethodId[0]?.id) {
            navigate("/dashboard");
          }
        } else {
          setMessage(data.error || "Error creating customer");
        }
      }
      else {
        console.log("Payment failed");
        setIsProcessing(false);
      }

      if (error) {
        setMessage(error.message);
        setIsProcessing(false);
        return;
      }
    } catch (err) {
      setMessage("Invalid card details");
      console.error("Payment error:", err);
    }

    setIsProcessing(false);
  };

  const handleAddressChange = (event) => {
    setErrors({ ...errors, address: event.complete })
  };

  const isValidUSZip = (zip) => {
    return /^\d{5}(-\d{4})?$/.test(zip); // Allows 5-digit ZIP or ZIP+4 format
  };

  const onFocus = (e, name) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  }


  useEffect(() => {
    const fetchOrgDetails = async () => {
      setIsProcessing(true)
      const orgDetails = await fetchOrganisationDetails(orgId)
      console.log("orgDetails", orgDetails)

      if (orgDetails?.status == "success") {
        const firstName = orgDetails?.data?.userData?.[0]?.firstName
        const lastName = orgDetails?.data?.userData?.[0]?.lastName
        const fetchedEmail = orgDetails?.data?.userData?.[0]?.email
        setEmail(fetchedEmail)
        setName(firstName + " " + lastName)
        setIsProcessing(false)
      }
    }

    fetchOrgDetails()
  }, [])

  //logs 
  // console.log("errors",errors)

  const handleCardFocus = () => setCardFocused(true)
  const handleCardBlur = () => setCardFocused(false)

  return (
    <form onSubmit={handleSubmit}>
      <div className="space-y-4">
        <div className="input-box">
          <div className="card-element-wrapper">
            <div className={`card-element-container ${cardFocused === true ? "focused" : ""}`} style={{ border: "1px solid #C7C7C7", borderRadius: "8px", marginBottom: "10px", backgroundColor: "white", padding: '2px' }} >
              <div className="stripe-input full-width" style={{ position: "relative", padding: "12px" }} >
                <div style={{ width: "100%" }}>
                  <CardNumberElement options={cardElementStyle} onChange={(e) => handleCardChange(e, "cardinfo")}  onFocus={handleCardFocus} onBlur={handleCardBlur} />
                </div>
                <div style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", display: "flex", gap: "5px", }} >
                  <img src={visa} alt="Visa" style={{ width: "30px", height: "20px" }} />
                  <img src={mastercard} alt="Mastercard" style={{ width: "30px", height: "20px" }} />
                  <img src={ax} alt="American Express" style={{ width: "30px", height: "20px" }} />
                  <img src={jcb} alt="JCB" style={{ width: "30px", height: "20px" }} />
                </div>
              </div>

              <div className="expiry-cvc-container" style={{ display: "flex", backgroundColor: "white" }} >
                <div className="expiry" style={{ flex: 1, alignItems: "center", padding: "12px", borderRight: "1px solid #C7C7C7" }} >
                  <CardExpiryElement options={cardElementStyle} onChange={(e) => handleCardChange(e, "cardexpiry")}  onFocus={handleCardFocus} onBlur={handleCardBlur} />
                </div>
                <div className="cvc" style={{ flex: 1, position: "relative", alignItems: "center", position: "relative", padding: "12px", }}>
                  <CardCvcElement options={cardElementStyle} onChange={(e) => handleCardChange(e, "cardcvc")}  onFocus={handleCardFocus} onBlur={handleCardBlur} />
                  <img src={cvc} alt="CVC Icon" style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", width: "23px", height: "21px", }} />
                </div>
              </div>

            </div>
            {/* {(errors.cardinfo || errors.cardexpiry || errors.cardcvc) && <div className="form-error">Please enter valid card information</div>} */}

            <AddressElement options={{ mode: "billing" }} onChange={handleAddressChange}/>
            {(errors.address) && <div className="form-error">{errors?.address}</div>}

          </div>
          <button type="submit" onClick={(e) => { handleSubmit(e); }} disabled={!stripe || isProcessing} className="create-account" >
            {isProcessing ? <CircularProgress color="inherit" size={24} /> : "Create Your Account"}
          </button>
          {message && <span className="form-error">{message}</span>}
        </div>
      </div>
    </form>
  );
};

const CheckoutFormV2 = () => {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm />
    </Elements>
  );
};

export default CheckoutFormV2;
